import React, { useEffect, useState } from "react";
import useStyles from "../MasterData.css";
import translation from "../../../i18n/i18.json";
import AllActions from "../../../actions";
import { useDispatch } from "react-redux";
import { FormError } from "../../../models/FormValidation/FormError";
import { FormFieldMeta } from "../../../models/FormValidation/FormFieldMeta";
import { MasterDataService } from "../../../services/MasterDataService";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import HighlightOffOutlinedIcon from "@material-ui/icons/HighlightOffOutlined";
import { ProcurementCategoryObj } from '../../../models/Master/ProcurementCategory';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  MenuItem,
  Select,
  TextField,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Table
} from "@material-ui/core";
import { InforDisplyaDuration,DropdownOptions_NonRM_Services_VendorCategory,NonRMCategoryManagedBys,ServicesCategoryManagedBys } from "../../../constants/AppConstants";
import { FormUtil } from "../../../utils/FormUtil";
import { FormValidateData } from "../../../models/FormValidation/FormValidateData";
import { VendorCategory } from "../../../models/Master/VendorCategory";
import { CategoryManagedBy } from "../../../models/Master/CategoryManagedBy";
interface ProcurementAddDialogProps {
  open: boolean;
  handleClose: any;
  dataObj: ProcurementCategoryObj;
  setDataObj: any;
  vendorCategoryList: VendorCategory[];
  successUpdate: any;
  isDisabledVendorCategory: boolean;
  categoryManagedByList: CategoryManagedBy[];
}

export default function ProcurementAddDialog(props: ProcurementAddDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    dataObj,
    setDataObj,
    vendorCategoryList,
    successUpdate,
    isDisabledVendorCategory,
    categoryManagedByList
  } = props;
  const initialState: ProcurementCategoryObj = {
    id: 0,
    name: "",
    vendorCategoryId: 0,
    vendorCategoryName: "",
    vendorCategoryList: [],
    isActive: true,
    procurementSubCategories: [],
    isDisabledVendorCategory: false,
    categoryManagedByList:[],
  };

  const [formErrors, setFormErrors] = useState<FormError[]>([]);
  const [subCategoryName, setSubCategoryName] = useState('');
  const [tableData, setTableData] = useState(dataObj.procurementSubCategories);
  const [fistSubmitDone, setFistSubmitDone] = useState(false);
  const [selectedCatManagedById, setSelectedCatManagedById] = useState(Number);
  const [allSpendManagedBys, setAllSpendManagedBys] = useState<CategoryManagedBy[]>([]);
  const nonRMSpendManagedList =[NonRMCategoryManagedBys.GroupProcurement,NonRMCategoryManagedBys.Legato,NonRMCategoryManagedBys.GroupProcurement_Legato];
  const servicesSpendManagedList =[ServicesCategoryManagedBys.GroupProcurement,ServicesCategoryManagedBys.SBU,ServicesCategoryManagedBys.GroupProcurement_SBU];
  const validateFieldsData: Array<FormFieldMeta> = [
    {
      fieldName: "name",
      isRequired: true,
      reuiredMsg: "Name is required"
    }]
  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };
  const handleAdd = () => {
    if(subCategoryName == null || subCategoryName == '')
    {
      dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_subcategory, InforDisplyaDuration.common));
    }
    else if(selectedCatManagedById==0 || selectedCatManagedById==null)
    {
      dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_categoryManagedBy, InforDisplyaDuration.common));
    }
    else {
      if (subCategoryName != null && subCategoryName.trim() && subCategoryName != '') {
      const found = tableData.find(s => s.name.toLocaleLowerCase() === subCategoryName.toLocaleLowerCase());
      if (found) {
        dispatch(AllActions.infoActions.openInforError(
          translation.master_procuementcategory_dialog_error_subcategory_exist, InforDisplyaDuration.common));
      }
      else {
        const newRow = { id: 0, name: subCategoryName, isActive: true ,refSpendManagedById:selectedCatManagedById,  categoryManagedbyName: allSpendManagedBys.filter(row => row.id == selectedCatManagedById)[0].name,};
        setTableData([...tableData, newRow]);
        tableData.push(newRow);
        dataObj.procurementSubCategories = tableData;
        setSubCategoryName('');
        setSelectedCatManagedById(0);
      }
    }
  }
    
    
  };

  const compeleteRequest = (success: boolean, message?: string) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(
            message,
            InforDisplyaDuration.common
          )
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(
            message,
            InforDisplyaDuration.common
          )
        );
      }
    }
  };
  useEffect(() => {
    if (fistSubmitDone) {
      //validateData();
    }
    if (dataObj.procurementSubCategories.length > 0) {
      setTableData(dataObj.procurementSubCategories);
      setAllSpendManagedBys([]);
      if(dataObj.vendorCategoryId==DropdownOptions_NonRM_Services_VendorCategory.NonRM)
      {
         categoryManagedByList.map((row: CategoryManagedBy) => {        
                      if (nonRMSpendManagedList.includes(row.id)) {                  
                        const newItem: CategoryManagedBy = { id: row.id, name: row.name }; 
                        setAllSpendManagedBys(prev => [...prev, newItem]);
                      }        
                    });       
      }
      else{
         categoryManagedByList.map((row: CategoryManagedBy) => {        
                      if (servicesSpendManagedList.includes(row.id)) {
                         const newItem: CategoryManagedBy = { id: row.id, name: row.name }; 
                        setAllSpendManagedBys(prev => [...prev, newItem])
                      }        
                    });
      }
    }
    else {
      setTableData([]);
    }
  }, [dataObj]);

  const handleExit = (e: any) => {
    setDataObj(initialState);
    setFormErrors([]);
    setFistSubmitDone(false);
    setTableData([]);
    setSubCategoryName('');
    setAllSpendManagedBys([]);
  };

  const handleSaveExit = (e: any) => {
    setFistSubmitDone(true);
    if (validateData()) {
      saveObject(function (status: boolean) {
        if (status) {
          setDataObj(initialState);
          setFormErrors([]);
          setFistSubmitDone(false);
          setTableData([]);
        }
        setTableData([]);
        setSubCategoryName('');
        handleClose();        
        setAllSpendManagedBys([]);
      });
    }
  };
  const validateData = () => {
    var isValid = true;
    if (dataObj.vendorCategoryId == null || dataObj.vendorCategoryId == 0) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_vendorcategory, InforDisplyaDuration.common));
    }
    else if (dataObj.name == null || dataObj.name == '') {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_procurementcategoryname, InforDisplyaDuration.common));
    }
    else if (dataObj.procurementSubCategories.length == 0) {
      isValid = false;
      dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_procurementsubcateries, InforDisplyaDuration.common));
    }
    let formValidateData: FormValidateData = FormUtil.validateFields(
      validateFieldsData,
      dataObj
    );

    setFormErrors(formValidateData.errorsList);
    return formValidateData.isValid && isValid;
  };

  const saveObject = (onSaveCallback: (status: boolean) => void) => {
    prepareForRequest();
    MasterDataService.saveProcurementCategory(
      dataObj,
      function (response) {
        if (response.result != null) {
          if (dataObj.id === 0) {
            compeleteRequest(true, translation.master_procurementcategory_dialog_save_suc);
            successUpdate(response.result, 0);
          } else {
            compeleteRequest(true, translation.master_procurementcategory_dialog_update_suc);
            successUpdate(response.result, 1);
          }
          onSaveCallback(true);
        }
        else if (response.message != null) {
          compeleteRequest(false, response.message);
          onSaveCallback(false);
        }
      },
      function (error: Error) {
        compeleteRequest(false, translation.master_add_dialog_save_error);
        onSaveCallback(false);
      }
    );
  };

  const handleChange = (input: string) => (e: any) => {

    if (input === "VendorCategory") {
      if(dataObj.procurementSubCategories.length>0)
      {
        dispatch(AllActions.infoActions.openInforError(
        translation.master_procuementcategory_dialog_error_cannotchangeVendorCategory, InforDisplyaDuration.common));
      }
      else
      {
      setDataObj({
        ...dataObj,
        vendorCategoryId: e.target.value
      });
      setAllSpendManagedBys([]);
      if(e.target.value==DropdownOptions_NonRM_Services_VendorCategory.NonRM)
      {
         categoryManagedByList.map((row: CategoryManagedBy) => {
        
                      if (nonRMSpendManagedList.includes(row.id)) {                     
                        const newItem: CategoryManagedBy = { id: row.id, name: row.name }; 
                        setAllSpendManagedBys(prev => [...prev, newItem]);
                      }        
                    });       
      }
      else{
         categoryManagedByList.map((row: CategoryManagedBy) => {        
                      if (servicesSpendManagedList.includes(row.id)) {
                         const newItem: CategoryManagedBy = { id: row.id, name: row.name }; 
                        setAllSpendManagedBys(prev => [...prev, newItem]);
                      }        
                    });
      }
    }
    }
    else if (input === "ProcurementCategoryName") {
      setDataObj({
        ...dataObj,
        name: e.target.value
      });

    } else {
      setDataObj({
        ...dataObj,
        [input]: e.target.value,
      });
    }
  };

   const handleCatManagedBy = () => (e: any, value: any) => {
    setSelectedCatManagedById(e.target.value);
  };

  const onDeleteRowClick = (row: any) => {
    const updatedTableData = tableData.filter((x) => x.name !== row.name);
    setTableData(updatedTableData);
    dataObj.procurementSubCategories = updatedTableData;
  };


  return (
    <div className={classes.popUpOuter}>
      <Dialog
        open={open}
        onClose={handleClose}
        onExit={handleExit}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <DialogTitle className={classes.popUpHeader} id="alert-dialog-title">
          {translation.master_procurementcategory_dialog_title}
        </DialogTitle>
        <DialogContent className={classes.NoPopWrapper} style={{ width: 800 }}>
          <div>
            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_procurement_dialog_vendorcategory}
              </span>
              <div className={classes.inputWrapper_Req}>
                <Select
                  variant="outlined"
                  onChange={handleChange("VendorCategory")}
                  value={dataObj.vendorCategoryId}
                  disabled={isDisabledVendorCategory}
                >
                  {vendorCategoryList.map((obj, index) => (
                    <MenuItem key={obj.id} value={obj.id}>
                      {obj.name}
                    </MenuItem>
                  ))}

                </Select>
              </div>
            </Grid>

            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
              <span className={classes.createLbl}>
                {translation.master_procurementcategory_dialog_procurementcategoryname}
              </span>
              <div className={classes.inputWrapper_Req}>
                <TextField
                  variant="outlined"
                  value={dataObj.name || ""}
                  onChange={handleChange("ProcurementCategoryName")}
                />
              </div>
            </Grid>


            <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>

              <span className={classes.createLbl}>
                {translation.master_procuementcategory_dialog_tableheader_subcategory}
              </span>
              <TableContainer className={classes.tblContainer}>
                <Table
                  size="small"
                  stickyHeader
                  aria-label="sticky table"
                  style={{ minWidth: "100px" }}
                >
                  <TableHead className={classes.tblHeader}>

                    <TableRow>
                      <TableCell>
                        <span className={classes.createLbl}>
                          {translation.master_procurementcategory_dialog_procurementsubcategoryname}
                        </span>
                        <div className={classes.inputWrapper_Req} style={{ width: '100%' }}>
                          <TextField
                            variant="outlined"
                            value={subCategoryName}
                            onChange={(e) => setSubCategoryName(e.target.value)}
                          />
                        </div>
                      </TableCell>
                      <TableCell>
                        <span className={classes.createLbl}>
                          {translation.master_procurementcategory_dialog_categorymanagedbyname}
                        </span>
                        <div className={classes.inputWrapper_Req} style={{ width: '100%' }}>
                           <Select
                      variant="outlined"
                      value={selectedCatManagedById||""}
                      onChange={handleCatManagedBy()}
                    >
                      {allSpendManagedBys.map((obj, index) => (
                        <MenuItem key={obj.name} value={obj.id}>
                          {obj.name}
                        </MenuItem>
                      ))}
                    </Select>
                        </div>
                      </TableCell>
                      <TableCell>

                        <div style={{ margin: "-5px 0px 0 10px;" }}>
                          {<Button onClick={handleAdd} style={{ float: "right", margin: "0px 47px", marginTop: "28px" }}>
                            <AddCircleIcon style={{ fill: "#19C626", width: "32px", height: "32px" }}></AddCircleIcon>
                          </Button>}
                        </div>

                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody className={classes.tblBody}>

                    {tableData.map((row, index) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.name}</TableCell>
                         <TableCell>{row.categoryManagedbyName}</TableCell>
                        <TableCell><div className={classes.rejectBtn} style={{ margin: "0px 59px" }}>
                          {<button onClick={(e) => onDeleteRowClick(row)} >
                            <HighlightOffOutlinedIcon></HighlightOffOutlinedIcon>
                          </button>}
                        </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </div>
          <DialogActions>
            <div style={{ margin: "20px ​10px 15px 0" }}>
              <div className={classes.greenBtnWrapperProcurementCatergory}>
                {<Button onClick={handleSaveExit} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.master_add_dialog_save_exit_btntxt}
                </Button>}
              </div>
              <div className={classes.grayBtnWrapperProcurementCatergory}>
                <Button onClick={handleClose} color="primary" autoFocus>
                  {translation.master_add_dialog_cancelbtntxt}
                </Button>
              </div>
            </div>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
